module.exports = __webpack_public_path__ + "img/formation_Personne.8fe0f171.png";